export default __webpack_public_path__ + "static/media/DNo.23-3.37da5b95.jpg";